import { useEffect, useState, useRef } from 'react';
import "./DownloadProgressModal.css";
// ============================================================
// DownloadProgressModal
// ------------------------------------------------------------
// مودال زیبا برای نمایش پیشرفت دانلود فایل کتاب کار
// ============================================================
const DownloadProgressModal = ({ open, progress }) => {
  const [displayPercent, setDisplayPercent] = useState(0);
  const [displaySpeed, setDisplaySpeed] = useState(0);
  const [displayReceived, setDisplayReceived] = useState(0);
  const lastUpdateRef = useRef(0);

  // ===== انیمیشن نرم اعداد =====
  useEffect(() => {
    if (!open) return;
    const now = Date.now();
    if (now - lastUpdateRef.current < 80) return; // throttle: هر ۸۰ms
    lastUpdateRef.current = now;

    setDisplayPercent(progress.percent || 0);
    setDisplaySpeed(progress.speed || 0);
    setDisplayReceived(progress.received || 0);
  }, [open, progress]);

  if (!open) return null;

  const total = progress.total || 0;
  const percent = Math.min(100, Math.max(0, displayPercent));
  const receivedMB = displayReceived / (1024 * 1024);
  const totalMB = total / (1024 * 1024);
  const speedMB = displaySpeed / (1024 * 1024);

  // تخمین زمان باقی‌مانده
  const remaining = speedMB > 0.01 && totalMB > 0
    ? Math.max(0, (totalMB - receivedMB) / speedMB)
    : 0;
  const remainingText = remaining > 0
    ? remaining < 60
      ? `حدود ${Math.ceil(remaining)} ثانیه`
      : `حدود ${Math.ceil(remaining / 60)} دقیقه`
    : 'در حال محاسبه...';

  const isIndeterminate = total === 0;

  return (
    <div className="wb-root">
      <div className="wb-download-backdrop">
        <div className="wb-download-modal">

          {/* ===== هدر با آیکن ===== */}
          <div className="wb-download-header">
            <div className="wb-download-icon">
              <svg viewBox="0 0 24 24" width="32" height="32" fill="none"
                stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="12" y1="18" x2="12" y2="12" />
                <polyline points="9 15 12 18 15 15" />
              </svg>
              <div className="wb-download-icon-pulse" />
            </div>
            <h3 className="wb-download-title">در حال آماده‌سازی کتاب کار</h3>
            <p className="wb-download-subtitle">
              لطفاً چند لحظه صبر کنید...
            </p>
          </div>

          {/* ===== نوار پیشرفت دایره‌ای ===== */}
          <div className="wb-download-circle-wrap">
            <svg className="wb-download-circle" viewBox="0 0 120 120">
              {/* پس‌زمینه */}
              <circle
                cx="60" cy="60" r="52"
                fill="none"
                stroke="var(--wb-border)"
                strokeWidth="8"
              />
              {/* نوار پیشرفت */}
              <circle
                cx="60" cy="60" r="52"
                fill="none"
                stroke="url(#wb-download-gradient)"
                strokeWidth="8"
                strokeLinecap="round"
                strokeDasharray={`${2 * Math.PI * 52}`}
                strokeDashoffset={`${2 * Math.PI * 52 * (1 - percent / 100)}`}
                transform="rotate(-90 60 60)"
                style={{
                  transition: 'stroke-dashoffset 0.25s ease-out',
                }}
              />
              <defs>
                <linearGradient id="wb-download-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="var(--wb-primary)" />
                  <stop offset="100%" stopColor="var(--wb-primary-light)" />
                </linearGradient>
              </defs>
            </svg>
            <div className="wb-download-percent">
              <span className="wb-download-percent-num">
                {percent.toFixed(0)}
              </span>
              <span className="wb-download-percent-sign">%</span>
            </div>
          </div>

          {/* ===== آمار ===== */}
          <div className="wb-download-stats">
            <div className="wb-download-stat">
              <span className="wb-stat-label">دریافت‌شده</span>
              <span className="wb-stat-value">
                {receivedMB.toFixed(1)}
                <small> / {totalMB.toFixed(1)} MB</small>
              </span>
            </div>
            <div className="wb-download-stat-divider" />
            <div className="wb-download-stat">
              <span className="wb-stat-label">سرعت</span>
              <span className="wb-stat-value">
                {speedMB.toFixed(2)}
                <small> MB/s</small>
              </span>
            </div>
          </div>

          {/* ===== زمان باقی‌مانده ===== */}
          {!isIndeterminate && (
            <p className="wb-download-remaining">
              زمان تخمینی باقی‌مانده: <strong>{remainingText}</strong>
            </p>
          )}

          {/* ===== نوار پیشرفت خطی ===== */}
          <div className="wb-download-bar">
            <div
              className="wb-download-bar-fill"
              style={{
                width: isIndeterminate ? '30%' : `${percent}%`,
                animation: isIndeterminate ? 'wb-indeterminate 1.5s ease-in-out infinite' : 'none',
              }}
            />
          </div>

          <p className="wb-download-hint">
            این پنجره پس از تکمیل دانلود به‌طور خودکار بسته می‌شود
          </p>

        </div>
      </div>
    </div>
  );
};

export default DownloadProgressModal;